<template>
  <div class="edit-header">
    <slot>
      <i v-if="backShow" class="edit-header-icon icon-back el-icon-back" @click="backTo"></i>
      <span class="header-title">{{ headerTitle }}</span>
      <i v-if="closeShow" class="edit-header-icon icon-close el-icon-close" @click="closeHandler"></i>
    </slot>
  </div>
</template>
<script>
export default {
  props: {
    headerTitle: String,
    backShow: {
      type: Boolean,
      default: false
    },
    closeShow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    listToEditPageNo() {
      return this.$store.state.edit.listToEditPageNo
    },
    isPaper() {
      return this.$store.state.book.isPaper || this.$route.query.type === 'paper'
    }
  },
  methods: {
    backTo() {
      // this.$router.go(-1)
      if (this.isPaper) {
        this.$router.push({ name: 'list', params: { to: 'paper', pageNo: this.listToEditPageNo } })
      } else {
        this.$router.push({ name: 'list', params: { to: 'book', pageNo: this.listToEditPageNo } })
      }
      this.$store.commit('edit/UPDATE_LIST_TO_PAGE_NO', 1)
    },
    closeHandler() {
      this.$emit('closeHandler')
    }
  }
}
</script>
<style lang="scss" scoped>
.edit-header {
  height: 40px;
  background-color: #df5813;
  color: #fff;
  line-height: 40px;
  font-size: 16px;
  width: 100%;
  text-align: center;
  .edit-header-icon {
    font-size: 16px;
    width: 40px;
    line-height: 40px !important;
    position: absolute;
    cursor: pointer;
    &.icon-back {
      left: 0;
    }
    &.icon-close {
      right: 0;
    }
  }
}
</style>
